import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
} from "@mui/icons-material";
import { theme } from "@theme";
import React from "react";
import { ScorecardObject } from "@providers/hop-ord-server/api";

interface ScorecardProps {
  data: ScorecardObject;
}

const OutcomeIcon = ({ outcome }: { outcome: string }) => {
  switch (outcome) {
    case "Passed":
      return <CheckCircleIcon sx={{ color: theme.palette.success.main }} />;
    default:
      return <ErrorIcon sx={{ color: theme.palette.warning.main }} />;
  }
};

const Scorecard = ({ data }: ScorecardProps) => {
  return (
    <Stack gap={1}>
      <TableContainer
        sx={{ backgroundColor: theme.palette.background.default }}
      >
        <Table size="small">
          <TableHead>
            <TableRow
              sx={{ th: { fontWeight: theme.typography.fontWeightBold } }}
            >
              <TableCell width="34%">Structure</TableCell>
              <TableCell width="33%">Plan Value</TableCell>
              <TableCell width="33%">Dosimetric Criteria</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.DVHStatistics.map(
              ({ Structure, DosimetricCriteria }, dvhStatisticIndex) => (
                <React.Fragment key={dvhStatisticIndex}>
                  {DosimetricCriteria.map(
                    (
                      { Outcome, Actual, Criterion },
                      dosimetricCriteriaIndex,
                    ) => (
                      <TableRow
                        sx={{
                          td: {
                            border:
                              dosimetricCriteriaIndex !==
                              DosimetricCriteria.length - 1
                                ? 0
                                : undefined,
                          },
                        }}
                        key={`${Structure}_${dosimetricCriteriaIndex}_${Criterion}`}
                        data-testid={`scorecard-row-${dvhStatisticIndex}-${dosimetricCriteriaIndex}`}
                      >
                        <TableCell width="34%" data-testid="structure">
                          <Typography variant="body2">
                            {dosimetricCriteriaIndex === 0
                              ? Structure
                              : undefined}
                          </Typography>
                        </TableCell>
                        <TableCell width="33%" data-testid="actual">
                          <Stack direction="row" alignItems="center" gap={1}>
                            <OutcomeIcon outcome={Outcome} />
                            <Typography variant="body2">{Actual}</Typography>
                          </Stack>
                        </TableCell>
                        <TableCell width="33%" data-testid="criterion">
                          <Typography variant="body2">{Criterion}</Typography>
                        </TableCell>
                      </TableRow>
                    ),
                  )}
                </React.Fragment>
              ),
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default Scorecard;
